const hiraToKata = (str) => {
  return str.replaceAll(/[\u3041-\u3096]/g, (match) => {
    const chr = match.codePointAt(0) + 0x60
    return String.fromCodePoint(chr)
  })
}

const isPointPartiallyMatched = (point, keyword) => {
  const pointJaMatched = new RegExp(keyword, 'i').test(hiraToKata(point.name))
  const pointKanaMatched = new RegExp(keyword, 'i').test(hiraToKata(point.name_kana))
  return pointJaMatched || pointKanaMatched
}

const isPointFullyMatched = (point, keyword) => {
  const pointJaFullMatched = new RegExp(`^${keyword}$`, 'i').test(hiraToKata(point.name))
  const pointKanaFullMatched = new RegExp(`^${keyword}$`, 'i').test(hiraToKata(point.name_kana))
  return pointJaFullMatched || pointKanaFullMatched
}

export const useGolfPointSearch = (searchPointList) => {
  const result = ref([])
  const keyword = ref('')

  const search = () => {
    if (keyword.value === '') {
      result.value = []
      return
    }

    const normalizedKeyword = hiraToKata(keyword.value).replaceAll('　', ' ')

    result.value = searchPointList
      .map((point) => {
        let score = 0
        if (isPointPartiallyMatched(point, normalizedKeyword)) score += 2
        if (isPointFullyMatched(point, normalizedKeyword)) score += 1
        return { ...point, score }
      })
      .filter((point) => point.score > 0)
      .toSorted((a, b) => b.score - a.score)
  }

  watch(keyword, search, { immediate: true })

  return {
    result,
    keyword
  }
}
